import React from 'react';
import { AlertTriangleIcon, KeyIcon, HammerIcon, HeartCrackIcon } from 'lucide-react';
const situations = [{
  title: 'Facing Foreclosure',
  description: 'Stop the bank and save your credit. We can buy your house quickly before the auction.',
  bgColor: 'bg-rose-950',
  icon: AlertTriangleIcon
}, {
  title: 'Inherited Property',
  description: 'Dealing with probate is hard enough. Sell an unwanted inherited home without the hassle.',
  bgColor: 'bg-[#0F1A2E]',
  icon: KeyIcon
}, {
  title: 'Major Repairs Needed',
  description: "Roof caving in? Fire damage? Mold? We buy properties that traditional buyers won't touch.",
  bgColor: 'bg-amber-950',
  icon: HammerIcon
}, {
  title: 'Divorce / Life Changes',
  description: 'Liquidate your assets quickly and fairly so you can move on to the next chapter of your life.',
  bgColor: 'bg-slate-900',
  icon: HeartCrackIcon
}];
export function SituationsGrid() {
  return <section className="py-20 md:py-28 px-6 md:px-12 lg:px-16" data-id="element-214">
      <div className="max-w-7xl mx-auto" data-id="element-215">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-8" data-id="element-216">
          <div className="max-w-2xl" data-id="element-217">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1B2A4A] mb-6 tracking-tight" data-id="element-218">
              We Help Homeowners in Any Situation
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-219">
              No matter why you need to sell, we have the experience and funds
              to help you solve your real estate problems quickly.
            </p>
          </div>
          <button onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} className="hidden md:inline-flex bg-[#1B2A4A] hover:bg-[#152238] text-white font-semibold py-3.5 px-8 rounded-md transition-colors whitespace-nowrap shadow-sm text-lg" data-id="element-220">
            Request Offer
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-221">
          {situations.map(situation => {
          const Icon = situation.icon;
          return <div key={situation.title} className={`group relative rounded-2xl overflow-hidden min-h-[280px] md:min-h-[320px] shadow-sm hover:shadow-xl hover:scale-[1.02] transition-all duration-300 p-8 flex flex-col justify-end border border-white/10 ${situation.bgColor}`} data-id="element-222">
                {/* Dark Gradient Overlay for depth */}
                <div className="absolute inset-0 bg-black/30 pointer-events-none" data-id="element-223" />

                {/* Large Background Graphic */}
                <Icon className="absolute top-[-10px] right-[-10px] w-36 h-36 text-white/10 pointer-events-none group-hover:scale-110 transition-transform duration-500" data-id="element-224" />

                <div className="relative z-10" data-id="element-225">
                  <Icon className="w-10 h-10 text-white/90 mb-6" data-id="element-226" />
                  <h3 className="text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-227">
                    {situation.title}
                  </h3>
                  <p className="text-white/80 leading-relaxed text-base max-w-md" data-id="element-228">
                    {situation.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}